export const DELIVERED = 'DELIVERED'
export const IN_TRANSIT = 'IN_TRANSIT'
export const PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED'
